export default __webpack_public_path__ + "static/media/hht1_ep18_timeline_q02_b.ef253687.png";